<template>
    <div>
      <div class="row table-row-background-color  non-mobile-admin-table">
        <div style="width: 10%; margin:auto">{{ row.ShipName }}</div>
        <div style="width: 15%;margin:auto">{{ row.IssueAt }}</div>
        <!-- <div style="width: 10%;margin:auto">{{ row.Port }}</div> -->
        <div style="width: 15%;margin:auto">{{ formatDate(row.DateFrom) }}</div>
        <div style="width: 15%;margin:auto">{{ formatDate(row.DateTo) }}</div>
        <!-- <div style="width: 15%;margin:auto">{{ formatDate(row.ValidDate) }}</div> -->
        <div style="width: 15%;margin:auto">{{ row.IssueBy }}</div>
        <div style="width: 10%;margin:auto">
          <div v-bind:class="colorSelected" style="padding:1px;">{{ row.CarbonRating }}</div>
        </div>
  
        <div style="width: 10%;margin:auto"> <button type="button" class="btn btn-success ship-selector-button"
            style="margin-bottom: 10px" v-on:click="downloader">
            Print
          </button></div>
        <div style="width: 10%;margin:auto"> <button type="button" class="btn btn-danger ship-selector-button"
            style="margin-bottom: 10px" v-on:click="deleter" :disabled="this.isUser">
            Delete
          </button></div>
      </div>
  
  
      <div class="row table-row-background-color  mobile-admin-table">
        <div style="width: 16%; margin:auto">{{ row.ShipName }}</div>
        <!-- <div style="width: 10%;margin:auto">{{ row.IssueAt }}</div>
        <div style="width: 10%;margin:auto">{{ row.Port }}</div> -->
        <div style="width: 16%;margin:auto">{{ formatDate(row.DateFrom) }}</div>
        <div style="width: 16%;margin:auto">{{ formatDate(row.DateTo) }}</div>
        <!-- <div style="width: 15%;margin:auto">{{ formatDate(row.ValidDate) }}</div> -->
        <div style="width: 18%;margin:auto">{{ row.IssueBy }}</div>
        <div style="width: 10%;margin:auto">
          <div v-bind:class="colorSelected" style="padding:1px;margin-top:-4px;width:20px;">{{ row.CarbonRating }}</div>
        </div>
  
        <div style="width: 10%;margin:auto"> <button type="button" class="btn btn-success ship-selector-button"
            style="margin-bottom: 10px;" v-on:click="downloader">
            Print
          </button></div>
        <div style="width: 14%;margin:auto;"> <button type="button" class="btn btn-danger ship-selector-button"
            style="margin-bottom: 10px;" v-on:click="deleter" :disabled="this.isUser">
            Delete
          </button></div>
      </div>
  
  
    </div>
  </template>
  
  <script>
  import TokenService from "../services/token.service";
  export default {
    name: "ReportsRow",
    props: ["row"],
    data() {
      return {
        name: "ReportsRow",
      };
    },
    methods: {
      formatRole(value) {
        let roleTitle = '';
        switch (value) {
          case 0:
            roleTitle = "User";
            break;
          case 1:
            roleTitle = "Administrator";
            break;
          case 2:
            roleTitle = "Super Administrator";
            break;
          default:
            roleTitle = "User";
        }
        return roleTitle;
      },
      formatDate(value) {
        let dateArray = value.split("T");
        return dateArray[0] + " " + dateArray[1];
      },
      downloader: function () {
        this.$emit("changedSelect", this.row);
      },
      deleter: function () {
        this.$emit("deleteSelect", this.row);
      },
    },
    computed: {
      isUser() {
        if(sessionStorage.getItem("user")==null){
          return true;
        }
        let user=TokenService.getUser();
    let role=user.role;
  if(role==0){
    return true;
  }else{
    return false;
  }
      },
      colorSelected() {

if (this.row.CarbonRating == "A") {
  return "ship-grade-a-indicator";
}

if (this.row.CarbonRating == "B") {
  return "ship-grade-b-indicator";
}

if (this.row.CarbonRating == "C") {
  return "ship-grade-c-indicator";
}

if (this.row.CarbonRating == "D") {
  return "ship-grade-d-indicator";
}

if (this.row.CarbonRating == "E") {
  return "ship-grade-e-indicator";
}
},
  
  
  
      formattedEmail() {
        let emailFormatted = this.row.Email;
        let emailArray = emailFormatted.split("@");
        emailFormatted = emailArray[0] + "\n@" + emailArray[1];
        return emailFormatted;
      },
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .fullEmail {
    display: inline;
  }
  
  .partialEmail {
    display: none;
  }
  
  @media screen and (max-width: 1000px) {
    .fullEmail {
      display: none;
    }
  
    .partialEmail {
      display: inline;
    }
  
  
  }
  </style>
  